import axios, { AxiosRequestConfig } from 'axios';
import { getOdataRootUrl } from '@bingads-webui-react/copilot-utils';

interface IGetWebSiteOrIPExclusionsUrlProps {
  accountId: string;
  customerId: string;
  userId: string;
  campaignId: string;
  adgroupId?: string;
}

export interface IFetchWebSiteOrIPExclusionsProps extends IGetWebSiteOrIPExclusionsUrlProps {
  ccToken: string;
}

export function getWebSiteOrIPExclusionsUrl({
  accountId,
  customerId,
  userId,
  campaignId,
  adgroupId,
}: IGetWebSiteOrIPExclusionsUrlProps): string {
  const queryString = new URLSearchParams({
    accountId,
    customerId,
    userId,
    campaignId,
    ...(adgroupId && { adgroupId }),
  });

  const exclusionType = adgroupId ? 'Newadgroup' : 'Newcampaign';

  return `${getOdataRootUrl()}/Campaign/${exclusionType}/GetExclusions?${queryString}`;
}

export function fetchWebSiteOrIPExclusionsData({
  accountId,
  customerId,
  userId,
  campaignId,
  adgroupId,
  ccToken,
}: IFetchWebSiteOrIPExclusionsProps) {
  const url = getWebSiteOrIPExclusionsUrl({
    accountId,
    customerId,
    userId,
    campaignId,
    adgroupId,
  });

  return axios.get(url, {
    headers: {
      Authorization: ccToken,
    },
    withCredentials: true,
  } as AxiosRequestConfig);
}
